/**
 * Query Keys for Groups Management Feature
 *
 * Single source of truth for all groups-related query keys.
 * Uses server-computed fields and single-item reorder operations.
 */

import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const GROUPS_MANAGEMENT = "groupsManagement";
const LIST = "list";
const REORDER = "reorder";
const DELETE_GROUP = "deleteGroup";

const groupsKeys = createKeys(featureKeys.GROUPS, {
    // Base key for all groups management queries
    all: () => [GROUPS_MANAGEMENT],

    // List of all groups (pre-sorted with computed fields)
    list: () => [GROUPS_MANAGEMENT, LIST],

    // Reorder mutation key
    reorder: () => [GROUPS_MANAGEMENT, REORDER],

    // Delete group mutation key
    deleteGroup: (ID) => [DELETE_GROUP, ID],
});

export default groupsKeys;
